<template>
  <span class="tree-span other-node"  v-show="model.isExpand ? model.isExpand : true" :class="otherNodeClass">
    <tr :class="levelClass+' '+tdClass">
      <th scope="col" class="td-title"
      @dblclick="handlerExpand(model)"
      >
      <!-- DRE -->
      <span class="open-close" v-if="model.filhos && model.filhos.length > 0" @click="handlerExpand(model)">
        <i :class="`fas ${!model.isExpand ? 'fa-caret-right' : 'fa-caret-down' }`"></i>
      </span>
      
      <!-- FLUXO DE CAIXA -->
      <span class="open-close" v-if="model.children && model.children.length > 0" @click="handlerExpand(model)">
        <i :class="`fas ${!model.isExpand ? 'fa-caret-right' : 'fa-caret-down' }`"></i>
      </span>
      
      
      <a class="ellipsis">
        <i class="t-icon m-dep"></i>
        <span :title="model.NomeDeExibicao ? model.NomeDeExibicao : model.nome">{{ model.NomeDeExibicao ? model.NomeDeExibicao : model.nome }}</span>
      </a>
    </th>
    <template v-if='model.meses && model.meses.length > 0'>  <!-- DRE -->
      <td 
      v-bind:key="i"  v-for="(mes, i) in model.meses" 
      :class="`td${i+1} ${mes.noStyle && mes.noStyle === true ? '' : colorItem(mes.valor)}`" 
      :style="`${mes.valor ? 'cursor:pointer' : ''}`"
      @click="verDetalhes(mes, $event, i, model)"
      >
      {{ formatarValores(mes) }}
    </td>
  </template>
  <template v-if='model.valores && model.valores.length > 0'> <!-- FLUXO DE CAIXA ANALÍTICO -->
    <td 
    v-bind:key="i"  v-for="(valor, i) in model.valores" 
    :class="`td${i+1} ${colorItem(valor.valor)}`" 
    :style="`${valor.Valor ? 'cursor:pointer' : ''}`"
    @click="verDetalhesFluxoAnalitico(model,i , $event)"
    >
    {{ toMoney(valor.valor, 2,true) }}
  </td>
  <td :class="`${colorItem(model.total.valor)}`">
    {{ toMoney(model.total.valor, 2,true) }}
  </td>
</template>
</tr>
<template v-if="model.filhos && model.filhos.length"><!-- DRE -->
  <tree-item
  v-show="model.isExpand"
  v-for="(m, i) in model.filhos"
  :key="String('child_node'+i)"
  :num='i'
  :root="1"
  @handlerExpand="handlerExpand"
  :nodes.sync='model.filhos && model.filhos.length'
  :trees.sync='trees'
  :datas.sync="datas"
  :model.sync="m">
</tree-item>
</template>
<template v-if="model.children && model.children.length"><!-- FLUXO DE CAIXA ANALÍTICO -->
  <tree-item
  v-show="model.isExpand"
  v-for="(m, i) in model.children"
  :key="String('child_node'+i)"
  :num='i'
  :root="1"
  @handlerExpand="handlerExpand"
  :nodes.sync='model.children && model.children.length'
  :trees.sync='trees'
  :datas.sync="datas"
  :model.sync="m">
</tree-item>
</template>
</span>
</template>

<script>
export default {
  name: 'treeItem',
  props: ['model', 'datas', 'num', 'nodes', 'root', 'trees'],
  data() {
    return {
      parentNodeModel: null,
      mes: null,
      loading:  true
    }
  },
  computed: {
    tdClass() {
      return this.root === 0 ? 'td-border' : 'not-border'
    },
    levelClass() {
      return this.model ? 'level-' + this.model.level : ''
    },
    otherNodeClass() {
      return this.model ? 'other-node-' + this.model.level : ''
    }
  },
  methods: {
    getParentNode(m) { // verifica os niveis
      const recurFunc = (data, list) => {
        data.forEach((l) => {
          if (l.id === m.id) this.parentNodeModel = list
          if (l.filhos) {
            recurFunc(l.filhos, l)
          }
        })
      }
      recurFunc(this.trees, this.trees)
    },
    handlerExpand(m) { // expandir ou recolher item treeview
      this.$emit('handlerExpand', m)
    },
    colorItem(mesValor) {
      let colorClass;
      
      if (mesValor < 0) {
        colorClass = 'text-danger';
      } else if (mesValor > 0) {
        colorClass = 'text-success';
      } else {
        colorClass = 'text-secondary';
      }
      
      return colorClass;
    },
    verDetalhes(mes,ev, index, model){ // emit informação de abrir modal e envial o model atual(clicado)
      
      document.querySelectorAll('.treeTable td').forEach((item) => {
        item.classList.remove('bg-detalhes')
      })
      document.querySelectorAll('.treeTable .tree-span').forEach((item) => {
        item.classList.remove('bg-detalhes-span')
      })
      
      if(ev.target){
        ev.target.classList.add('bg-detalhes')
        this.$el.classList.add('bg-detalhes-span')
      }
      if(mes){
        mes.index = index;
        mes.filhosDt = model.filhos && model.filhos.length ? model.filhos : model;
        
        if(!mes.valor){ return false }
        if(mes.detalhes == null || mes.detalhes.length == 0){
          return false
        }
        
        this.$root.$emit('bv::show::modal','modal-detalhes-dre')
        this.$root.$emit('modalDetalhes', mes)
      }else{
        return false;
      }
    },
    verDetalhesFluxoAnalitico(model, index, ev) {
      document.querySelectorAll('.treeTable td').forEach((item) => {
        item.classList.remove('bg-detalhes')
      })
      document.querySelectorAll('.treeTable .tree-span').forEach((item) => {
        item.classList.remove('bg-detalhes-span')
      })
      
      if(ev.target){
        ev.target.classList.add('bg-detalhes')
        this.$el.classList.add('bg-detalhes-span')
      }
      
      if(model){
        model.index = index;
        model.datas = this.datas;
        
        this.$root.$emit('bv::show::modal','modal-detalhes-fluxoanalitico')
        this.$root.$emit('modalDetalhesaFluxo', model)
      }else{
        return false;
      }
    }
  },
  watch: {
    loading: function (val){
      this.$root.$emit('loading', val)
    }
  },
  mounted(){
    this.loading = false
  }
}
</script>
<style>
.bg-detalhes{
  background:#96d9f9 !important;
}
div.treeTable tbody span.tree-span.bg-detalhes-span,
div.treeTable tbody span.tree-span.bg-detalhes-span tr.td-border,
div.treeTable tbody span.tree-span.bg-detalhes-span tr.not-border,
div.treeTable tbody span.tree-span.bg-detalhes-span th.td-title {
  background:#d7eef9 !important;
}
</style>
